module.exports = __webpack_public_path__ + "static/img/code.985a4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.png
// module id = Cwdn
// module chunks = 3